<div class="container-fluid">
  <div class="row">
    <div class="col-12 col-sm-6 col-lg-3">
      <span class="subtitles">{{"SYSTEM.READONLY.COUNTRY" | translate}}: </span>
      <p class="content">{{country_name}}</p>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <span class="subtitles">{{"SYSTEM.READONLY.ADDRESS" | translate}}: </span>
      <p class="content">{{stepTwo?.location_address}}</p>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <span class="subtitles">{{"SYSTEM.READONLY.CITY" | translate}}: </span>
      <p class="content">{{stepTwo?.location_city}}</p>
    </div>
    <div class="col-12 col-sm-6 col-lg-3">
      <span class="subtitles">{{"SYSTEM.READONLY.POSTALCODE" | translate}}: </span>
      <p class="content">{{stepTwo?.location_postalcode}}</p>
    </div>

    <div *ngIf="imagesStep.length > 0" class="col-12 mb-2 text-center">
      <span class="subtitles">{{"SYSTEM.READONLY.ATTACHEDFILES" | translate}}</span>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-center mt-2">
        <ng-container *ngFor="let image2 of imagesStep">
          <div *ngIf="image2.src" class="col-xs-12 col-sm-6 col-md-2 mb-4 text-center"
            style="width: 100px; height: 100px;">
            <ng-container *ngIf="image2.ext != 'pdf'; else pdfBlock">
              <ng-container *ngIf="isImageFile(image2.ext); else generic">
                <img [src]="urlServerLaraMedia + image2.src" [alt]="image2.title" class="img-fluid thumbnailImg"
                  (click)="viewImage(image2)">
              </ng-container>
              <!-- If it's neither PDF nor a valid image extension, display a generic icon -->
              <ng-template #generic>
                <a [href]="urlServerLaraMedia+image2.src" target="_blank">
                  <img src="assets/img/fileThumbnail.png" [alt]="image2.title" class="img-fluid thumbnailImg">
                </a>
              </ng-template>
            </ng-container>
            <ng-template #pdfBlock>
              <a [href]="urlServerLaraMedia+image2.src" target="_blank">
                <img src="assets/img/pdfThumbnail.png" [alt]="image2.title" class="img-fluid thumbnailImg">
              </a>
            </ng-template>
          </div>
          <!-- <div *ngIf="image2.src && readonlyPopup; else noModal" class="col-xs-12 col-sm-6 col-md-2 mb-4 text-center"
            style="width: 100px; height: 100px;" data-bs-toggle="modal" data-bs-target="#exampleModal"
            (click)="viewImage(image2)">
            <img [src]="urlServerLaraMedia+image2.src" [alt]="image2.title" class="img-fluid thumbnailImg">
          </div>
          <ng-template #noModal>
            <div class="col-xs-12 col-sm-6 col-md-2 mb-4 text-center" style="width: 100px; height: 100px;">
              <img [src]="urlServerLaraMedia+image2.src" [alt]="image2.title" class="img-fluid thumbnailImg">
            </div>
          </ng-template> -->
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Visualizzazione immagine -->
<!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <img *ngIf="selectedImage" [src]="selectedImage" style="width: 150%; height: auto;">
    </div>
  </div>
</div> -->
